import { Component, Input, OnInit } from '@angular/core';
import { FormFieldAbstractComponent } from '../abstract.component';
import { provideTranslation } from '@skyeng/libs/shared/i18n';

@Component({
  selector: 'crm-form-field-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  viewProviders: [provideTranslation('formFieldTextarea', () => import.meta.webpackContext!('./translation'))],
})
export class FormFieldTextareaComponent extends FormFieldAbstractComponent implements OnInit {
  @Input() minRows = 1;
  @Input() maxRows = 5;
}
